import { useState } from "react";
import { fieldNames } from "../../../src/components/LegalForm/steps/step4/utils";

export const {
  LEGAL_FORM,
  TIN,
  GEORGIAN_NAME,
  LATIN_NAME,
  INCORPORATION_COUNTRY,
  OTHER_COUNTRY,
  MOBILE_NUMBER,
  EMAIL,
  ACTUAL_ADDRESS,
  COUNTRY,
  CITY,
  CITY_VILLAGE,
  STREET,
  HOME_NUMBER,
  APARTMENT_NUMBER,
  VILLAGE,
} = fieldNames;

const initAddress = {
  [COUNTRY]: "",
  [CITY]: "",
  [STREET]: "",
  [CITY_VILLAGE]: "",
  [HOME_NUMBER]: "",
  [APARTMENT_NUMBER]: "",
  [VILLAGE]: "",
};
const initState = {
  [ACTUAL_ADDRESS]: {
    ...initAddress,
  },
  [LEGAL_FORM]: [],
  [TIN]: "",
  [GEORGIAN_NAME]: "",
  [LATIN_NAME]: "",
  [INCORPORATION_COUNTRY]: [
    {
      referenceId: 268,
      referenceNameGe: "საქართველო",
      referenceNameEn: "Georgia",
    },
  ],
  [OTHER_COUNTRY]: "",
  [MOBILE_NUMBER]: "",
  [EMAIL]: "",
};

function useStepFourValues() {
  const [stepFourValues, setStepFourValues] = useState(initState);
  return { stepFourValues, setStepFourValues };
}

export default useStepFourValues;
